import {getFieldLabel, translate} from "helpers/common"
import {Model} from "Model"
import {Settings} from "types/settings"
import {DataType, DefaultDataType, CheckboxType, InitialType} from "types/tasks"
import {getStudentDataTemplateFields} from "types/templates"

export const DATA_TYPES = [
    {id: DataType.TEXT, name: translate("tasks:dataType.text")},
    {id: DataType.NUMERIC, name: translate("tasks:dataType.numeric")},
    {id: DataType.DATE, name: translate("tasks:dataType.date")},
    {id: DataType.SOCIAL_SECURITY_NUMBER, name: translate("tasks:dataType.socialSecurityNumber")}
]

export const GRADE_DATA_TYPES = [{id: DataType.NUMERIC, name: translate("tasks:dataType.numeric")}]

export const DEFAULT_DATA_TYPES = [
    {id: DefaultDataType.NO_DEFAULT, name: translate("tasks:defaultDataType.noDefault")},
    {id: DefaultDataType.MANUAL_TEXT, name: translate("tasks:defaultDataType.manualText")},
    {id: DefaultDataType.STUDENT_DATA, name: translate("tasks:defaultDataType.studentData")}
]

export const CHECKBOX_TYPES = [
    {id: CheckboxType.SINGLE, name: translate("tasks:checkboxType.single")},
    {id: CheckboxType.MULTIPLE, name: translate("tasks:checkboxType.multiple")}
]

export const INITIAL_TYPES = [
    {id: InitialType.SINGLE, name: translate("tasks:initialType.single")},
    {id: InitialType.MULTIPLE, name: translate("tasks:initialType.multiple")}
]

export const getStudentDataValues = (model: Model) => {
    return getStudentDataTemplateFields(model).map((group) => ({
        ...group,
        options: group.options.map((option) => {
            if (option.fieldLabel) {
                const fieldLabel = getFieldLabel(model, option.fieldLabel, option.name)
                return {...option, name: fieldLabel}
            }
            return {...option}
        })
    }))
}
